<div class="full-height"
     [ngClass]="{'layout-column layout-align-center-end': isSmall, 'layout-row layout-align-start-center': !isSmall}">

  <div class="br-body-1 margin-right-10" *ngIf="!isSmall && !isHideTaskStatusTime">
    <span *ngIf="task.status !== taskStatusTypes.ContactNotAvailable">{{task | bringozTime: 'statusUpdatedAt'}}</span>
    <span *ngIf="task.status === taskStatusTypes.ContactNotAvailable">{{task.contactNotAvailableCode}}</span>
  </div>

  <div *ngxPermissionsExcept="'services.actions'"
       class="task-status-button layout-row layout-align-center-center"
       [ngClass]="isSmall ? 'small ' +  status : status">

    <span
      class="br-caption-2 text-uppercase">{{isSmall ? ('STATUS_TAG.' + status | translate) : ('SERVICE_TASK_STATUS.' + status | translate)}}</span>
  </div>


  <div *ngxPermissionsOnly="'services.actions'"
       ngbDropdown
       container="body"
       [ngbTooltip]="isSmall ? tooltipTmpl : null" openDelay="300" triggers="hover">
    <button id="dropdownBasic1"
            appBringozIdGenerator="openStatusMenuBtn"
            class="task-status-button layout-row layout-align-center-center"
            [disabled]="!allowStatusChangeAction"
            [ngClass]="isSmall ? 'small ' +  status : status"
            (click)="$event.stopPropagation();"
            ngbDropdownToggle>

      <span
        class="br-caption-2 text-uppercase">{{isSmall ? ('STATUS_TAG.' + status | translate) : ('SERVICE_TASK_STATUS.' + status | translate)}}</span>

      <bringoz-icon *ngIf="actionable && !loading && allowStatusChangeAction" iconName="chevron-down"></bringoz-icon>

      <div *ngIf="loading" class="spinner-border margin-left-5" role="status">
        <span class="sr-only"></span>
      </div>

    </button>


    <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="padding-top-10 padding-bottom-10">

      <div *ngFor="let statusOption of taskStatusOptions; let last = last" ngbDropdownItem class="padding-5">
        <button class="task-status-button full-width"
                [ngClass]="statusOption"
                (click)="onChangeStatus(statusOption, $event)">
          <span>{{'SERVICE_TASK_STATUS.' + statusOption | translate}}</span>
        </button>
      </div>

    </div>
  </div>

  <div class="br-body-1 margin-top-5" *ngIf="isSmall && !isHideTaskStatusTime">
    <span *ngIf="task.status !== taskStatusTypes.ContactNotAvailable">{{task | bringozTime: 'statusUpdatedAt'}}</span>
    <span *ngIf="task.status === taskStatusTypes.ContactNotAvailable">{{task.contactNotAvailableCode}}</span>
  </div>

</div>

<ng-template #tooltipTmpl>
  <div class="layout-column">
    {{status | translate}}
  </div>
</ng-template>
